import {PaymentServiceInterface} from "interfaces/payment-service.ts"
import {BaseBusinessService} from "services/mms/external-api/business/base-business-service"

export class BusinessPaymentService
    extends BaseBusinessService
    implements PaymentServiceInterface {
    useGetSelfPayment() {
        return this.get({endpoint: ""})
    }

}
